export const TABLE_SHORTCODE = '[#table#]'
